define((require) => {
    "use strict";

    var AbstractProjectAttachView               = require("ui/projects/AbstractProjectAttachView"),
        _                                       = require("underscore"),
        Promise                                 = require("shared/util/Promise"),
        ContentCollection                       = require("data/ContentCollection"),
        DashboardSorting                        = require("ui/dashboard/DashboardSorting"),
        UserCollection                          = require("ui/user/UserCollection"),
        LoggedIn                                = require("shared/security/LoggedIn"),
        ProjectContext                          = require("ui/editor/project/ProjectContext"),
        ProjectAttachContentItemView            = require("ui/projects/content/ProjectAttachContentItemView"),
        LoggedInUserState                       = require("shared/ui/user/LoggedInUserState"),
        DashboardContentCollectionView          = require("ui/dashboard/DashboardContentCollectionView");

    var NOTIFICATION_MESSAGE = "You have selected Items which will be moved from other Projects";

    var CollectionView = DashboardContentCollectionView.extend({

        itemView: ProjectAttachContentItemView,

        itemViewOptions: function() {
            return {
                contentMap: ProjectContext.mapContent()
            };
        }

    });

    /**
     *
     * @class ProjectAttachContentCollectionView
     *
     */
    return AbstractProjectAttachView.extend("ProjectAttachContentCollectionView", {

        className: AbstractProjectAttachView.prototype.className + " content",

        collectionView: CollectionView,

        _contentMap: null,

        collectionOptions: function() {
            var collection = new ContentCollection();

            return Promise.all([
                ContentCollection.count(),
                collection.query(DashboardSorting.current().query),
                // We need the list of users to correctly render "Created By"...
                new UserCollection().fetch()
            ])
                .then((results) => {
                    return {
                    // The 'header' is reserved for the 'AbstractProjectAttachView'
                        header: {
                            label: "Experiences",
                            count: results[0]
                        },
                        // Hide the "Create experience disclaimer" when inside the attach view
                        showCreateDisclaimer: false,
                        collection: collection,
                        principal: LoggedIn.principal(),
                        users: results[2]
                    };
                });
        },

        initialize: function() {
            this.__super();

            this._contentMap = ProjectContext.mapContent();
        },

        onSelect: function(model, selected, selectedAssets) {
            // We display a warning message if the user selects content belonging to another project.
            var projectId = this.options.projectContext.project.get("id"),
                contentMap = this._contentMap,
                showNotification = !!_.find(selectedAssets, (asset) => {
                    var otherProjectId = contentMap.get(asset.get("id"));

                    return otherProjectId && otherProjectId !== projectId;
                });

            this.showNotification(showNotification && NOTIFICATION_MESSAGE);
        },

        onAttach: function(selectedAssets) {
            var self = this,
                projectId = self.options.projectContext.project.get("id"),
                promises = [Promise.resolved()];

            // When attaching content from other projects - re-fech/sync those to keep
            // models (and selector thumbs) updated.
            selectedAssets.forEach((asset) => {
                var assetProjectId = self._contentMap.get(asset.get("id"));

                if (assetProjectId && assetProjectId !== projectId) {
                    var project = LoggedInUserState.get("projects").get(assetProjectId);

                    promises.push(project.fetch());
                }
            });

            return Promise.all(promises);
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/content/ProjectAttachContentCollectionView.js